import { get, post } from './httpClient'

export const getCarrier = (object) => get('/carrier', object)
export const getCarrierCreate = (object) => post('/carrier/create', object)
export const updateCarrier = (object) => post('/carrier/update', object)
export const searchCarrier = (object) => get('/carrier', object)
